<template>
  <aside class="main-sidebar">
    <section class="sidebar">
      <ul class="sidebar-menu">
        <li class="header"><strong>Menu</strong></li>
        <li class="treeview menu-open">
          <a href="#">
            <i class="fa fa-pie-chart"></i>
            <span>Relatórios</span>
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"></i>
            </span>
          </a>
          <ul class="treeview-menu" v-bind:style="reportsMenuStyle">
            <router-link :to="{ name: 'QuizReports' }" tag="li"><a><i class="fa fa-bar-chart"></i>Questionários</a></router-link>
            <li class="treeview">
              <a href="#">
                <i class="fa fa-align-center"></i>
                <span>Segmentados</span>
                <span class="pull-right-container">
                  <i class="fa fa-angle-left pull-right"></i>
                </span>
              </a>
              <ul class="treeview-menu" v-bind:style="reportsMenuStyle">
                <router-link :to="{ name: 'SegmentedChartsReports' }" tag="li"><a><i class="fa fa-line-chart"></i> <span>Gráficos</span></a></router-link>
                <router-link :to="{ name: 'SegmentedTextualReports' }" tag="li"><a><i class="fa fa-file-text-o"></i> <span>Textuais</span></a></router-link>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <!-- /.sidebar-menu -->
    </section>
    <!-- /.sidebar -->
  </aside>
</template>
<script>
export default {
  name: 'PartnerSidebar',
  computed: {
    reportsMenuStyle () {
      let reportsRoutesNames = ['SegmentedChartsReports', 'SegmentedTextualReports', 'QuizReports']
      return {
        display: reportsRoutesNames.indexOf(this.$route.name) > -1 ? 'block' : ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// PartnerSidebar.vue?17db8678